// Card.js
import React, { useEffect, useState, useRef, useContext } from 'react';
import { Card as MuiCard, CardContent, Typography, CardHeader, Box, Grid, Divider } from '@mui/material';
import { formatarDataHora, numberWithCommas, identificacaoUsuarioLogado } from '../../utils';
import ImpressaoIcon from '../../assets/img/impressora.svg';
import CloseIcon from '../../assets/img/close.svg';
import LogoNafil from '../../assets/img/NAFIL_logo.svg';
import LogoN from '../../assets/img/NAFIL_logoCurto.svg';
import Button from '@mui/material/Button';
import { MyContext } from '../../context/MyContext';
import Avatar from '@mui/material/Avatar';
import { ReactToPrint, useReactToPrint } from 'react-to-print';
import QRCodeStyling from "qr-code-styling";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginaCardNotasFaturadasReciboPagamentos from '../CardNotasFaturadasRecibosPagamentos/CardNotasFaturadasRecibosPagamentos';
import api from '../../services/api';
import { useLocation, useHistory } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';

const Card = (props) => {

    console.log("MVJOAO ", props);

    const { showModalMeuPagamentoFaturado, setShowModalMeuPagamentoFaturado } = useContext(MyContext);
    const { destinoPagina, setDetinoPagina } = useContext(MyContext);
    const [urlQRCode, setUrlQRCode] = useState("");
    const [processoNumero, setProcessoNumero] = useState("");
    const [processoData, setProcessoData] = useState("");
    const [colunas, setColunas] = useState([[], [], []]);  // Array para armazenar as colunas
    const [satonImpressaoProcessoId, setSatonImpressaoProcessoId] = useState(0);
    const [satonImpressaoProcessoIdLoja, setSatonImpressaoProcessoIdLoja] = useState(0);
    const [dadosConteudoParaImpressao, setDadosConteudoParaImpressao] = useState([]);    
    const [satonOriginal, setSatonOriginal] = useState([]);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const { showModalMeuPagamentoFaturadoReciboDePagamento, setShowModalMeuPagamentoFaturadoReciboDePagamento } = useContext(MyContext);
    const componentRef = useRef();
    const history = useHistory();
    let vendaAtual = null;  // Variável para rastrear a venda atual
    let vendasAgrupadas = [];  // Armazena as vendas agrupadas por id_venda
    const linhasPorColuna = 8; // Definindo limite de linhas por coluna
    let colunaAtual = -1;  // Coluna atual (0 = esquerda, 1 = centro, 2 = direita) -1 Porque Será Somado 1 ao inciar
    let linhasPreenchidas = 0;  // Contador de linhas preenchidas
    let itensNaPagina = 0;  //
    let limiteLinhasPorPagina = Math.ceil( (props.props == 'undefined' ? props.satonParcial.length / 3 : props.props.satonParcial.length / 3 ));  // Notas Inteiras ou Contador de linhas preenchidas
    let vendasAgrupadasLinhasPorColuna = [];  // Armazena as vendas agrupadas por id_venda
    const qrCodeRef = useRef(null);
    const dataToPrintRef = useRef();
    let _temPIXpendente = null;

    const toastMarcarItensParaImpressao = () => toast.error("Selecione Algum Item Para Impressão!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastMensagemError = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const modalStyleReciboPagamentos = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '500px',
        width: '90%', // Garante responsividade e centralização mesmo em telas menores
        bgcolor: 'background.paper',
        boxShadow: 24,
        // p: 4, // Padding interno do modal (opcional)
        overflow: 'auto',
    }

    useEffect(() => {
        if (props.props == undefined){
            console.log("BOOIA ", props);
            setDadosConteudoParaImpressao(props);
            montarImpressao(props);  // TAMBÉM ADICIONADO NA PÁGINA FaturadoLinkDePagamento.jsx
        }
        else{
            console.log("BOOIAB ", props.props);
            setDadosConteudoParaImpressao(props.props);
            montarImpressao(props.props);
        }        
    }, []);

    const handlePrint = useReactToPrint({
        content: () => dataToPrintRef.current
    });

    
    const handleCloseModal = () => {        
        if (destinoPagina != ""){
            // setDetinoPagina("home");
            history.push('/');
        }
        setShowModalMeuPagamentoFaturado(false);
    }


    const functionCopyToClipboard = async (e) => {
        navigator.clipboard.writeText(urlQRCode);
        pixCopiadoSucesso("PIX Copiado com Sucesso");
    }

    const pixCopiadoSucesso = (nome) => toast.success("PIX Copiado com Sucesso B",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 1500 });

    const adicionarObjetoNaColuna = (colunaIndex, objeto) => {
        setColunas((prevColunas) => {
            // Cria uma cópia das colunas anteriores para evitar mutação
            const novasColunas = [...prevColunas];
            // Adiciona o objeto à coluna correspondente
            novasColunas[colunaIndex] = [...novasColunas[colunaIndex], objeto];
            return novasColunas;
        });
    };

    const handleCompartilharLinkPagamento = async () => {
        const _linkPagamentoFaturado = "";

        if (selectionModel == null || selectionModel.length == 0) {
            toastMarcarItensParaImpressao();
        }
        let _itensSelecionados = [];

        selectionModel.forEach((item) => {
            if (item.substring(0, 1) == "-") {
                _itensSelecionados.push(item.substring(1, item.length));
            }
            else {
                _itensSelecionados.push(item);
            }
        });
        _itensSelecionados = satonOriginal.filter((item) => {
            return _itensSelecionados.includes(item.ids_saton.toString() + "-" + item.ids_saton_loja.toString());
        });
        let _processosSelecionados = [];
        _itensSelecionados.forEach((item) => {
            if (item.processo != null) { // } && item.processo > 0) {
                let _registroProcesso = item.processo + "-" + item.processo_loja;
                if (_processosSelecionados.indexOf(_registroProcesso) === -1) {
                    _processosSelecionados.push(_registroProcesso);
                }
            }
        });
        let usuario_logado = identificacaoUsuarioLogado();
        let _userId = usuario_logado.split('_')[0];
        let _userIdloja = usuario_logado.split('_')[1];
        //let _nomeFullRazaoSocialLogado = identificacaoRazaoSocialUsuarioLogado();
        for (const itemSelect of _processosSelecionados) {
            setSatonImpressaoProcessoId(itemSelect.split('-')[0]);
            setSatonImpressaoProcessoIdLoja(itemSelect.split('-')[1]);
            let _processoId = itemSelect.split('-')[0]
            let _processoIdLoja = itemSelect.split('-')[1]

            const dados = JSON.parse(`{"plainText":"idCliente=${_userId}/idClienteLoja=${_userIdloja}/idPreVenda=0/idPreVendaLoja=0/idProcesso=${_processoId}/idProcessoLoja=${_processoIdLoja}"}`);
            try {
                let APIdados = await api.post(`Saton/CriarLinkPagamentoFaturado60minutos`, dados)
                    .then((response) => {
                        // console.log("DEUS => ", response.data);
                        _linkPagamentoFaturado = response.data;
                        // setDadosConteudoParaImpressao(response.data);
                        // setShowModalMeuPagamentoFaturado(true);
                    })
                    .catch((erro) => {
                        setDadosConteudoParaImpressao(null);
                        toastMensagemError("Falhou: " + erro.message)
                    });
            } catch (e) {
                setDadosConteudoParaImpressao(null);
                toastMensagemError("Falha Geral: " + e.message)
                return null;
            };
        };
        console.log("LINKOUUUU ", _linkPagamentoFaturado );
    };


    useEffect(() => {
        if (urlQRCode != null && urlQRCode.length > 0) {
            const qrCode = new QRCodeStyling({
                width: 200,
                height: 200,
                data: urlQRCode,
                image:
                    LogoN,
                dotsOptions: {
                    color: "#000000",
                    type: "rounded"
                },
                imageOptions: {
                    crossOrigin: "anonymous",
                    margin: 5
                }
            });

            qrCode.append(qrCodeRef.current);
            //  qrCode.update({
            //     data: urlQRCode
            //  });    
            // const intervalID = setInterval(myCallback, 2000, 'Parameter 1', 'Parameter 2');
            // const intervalID = setInterval(verificarPagamentosPIX, 6000, 'Parameter 1', 'Parameter 2');
        }
    }, [urlQRCode]);


    const montarImpressao = (props) => {
        _temPIXpendente = props.especieParcial.filter((xp) => xp.nband == 17 && xp.pix_recebido == null);

        // Agrupar as vendas com base no id_venda
        props.satonParcial.forEach((xprod, index) => {
            const vendaId = xprod.id_venda + "-" + xprod.id_venda_loja;
            if (processoNumero == "") {
                setProcessoNumero(xprod.processo + "-" + xprod.processo_loja);
                setProcessoData(props.fatorParcial.data);
            }
            if (vendaAtual !== vendaId) {
                vendaAtual = vendaId;
                const totalVenda = calcularTotalVenda(vendaId); // Calcula o total da venda
                // className="page-break" Vem do Arquivo APP.CSS
                // Itens Vendidos, Créditos ou Itens Devolvidos
                const linhasNessaNota = props.satonParcial.filter(prod => (prod.id_venda + "-" + prod.id_venda_loja) === vendaId).length;
                linhasPreenchidas = linhasPreenchidas + linhasNessaNota;
                if (colunaAtual === -1 || linhasPreenchidas >= limiteLinhasPorPagina) {
                    colunaAtual = (colunaAtual + 1) % 3;  // Mudar para a próxima coluna (cíclico entre 0, 1, 2)
                    linhasPreenchidas = 0;  // Reiniciar o contador de linhas
                };
                
                let exibirObjeto = (
                    // vendasAgrupadas.push(
                    <MuiCard variant="outlined" key={vendaId} paddingLeft={'0px'} margin={'0px'} textAlign={'left'} style={{ margin: '0px', padding: '0px' }}>
                        {/* { ( vendasAgrupadasLinhasPorColuna % limiteLinhasPorPagina == 0 ? <div className="page-break"></div> : <></> ) }   */}
                        <CardHeader
                            title={
                                <Box display="flex" justifyContent="space-between">
                                    <Typography variant="h6" fontSize={'12px'}>{vendaId}</Typography>
                                    <Typography variant="h6" fontSize={'12px'}>{formatarDataHora(xprod.data, 4)}</Typography>
                                </Box>
                            }
                            sx={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '-15px' }}
                        />
                        <CardContent style={{ padding: '0px', marginTop: '-10px' }}>
                            <Grid container spacing={0} sx={{ margin: '0', padding: '0', marginTop: '5px', marginLeft: '5px', paddingRight: '10px' }}>
                                <Grid item xs={12}><Divider sx={{ marginTop: '-10px' }} style={{ height: '4px', alignSelf: 'center' }} /></Grid>
                                {/* Cabeçalhos das colunas */}
                                <Grid item xs={2} fontSize={'7.5px'} textAlign={'left'}><strong>Quantidade</strong></Grid>
                                <Grid item xs={2} fontSize={'7.5px'} textAlign={'left'}><strong>Código</strong></Grid>
                                <Grid item xs={6} fontSize={'7.5px'} textAlign={'left'}><strong>Descrição</strong></Grid>
                                <Grid item xs={2} fontSize={'7.5px'} textAlign={'right'}><strong>Total R$</strong></Grid>

                                {/* Renderizar dos Itens da Venda */}
                                {props.satonParcial
                                    .filter(prod => (prod.id_venda + "-" + prod.id_venda_loja) === vendaId)
                                    .map((prod, i) => (
                                        <React.Fragment key={i}>
                                            <Grid item xs={2} fontSize={'11px'}>
                                                {numberWithCommas(prod.quantidade)}
                                            </Grid>
                                            <Grid item xs={2} fontSize={'11px'}>
                                                {prod.codigo}
                                            </Grid>
                                            <Grid item xs={6} fontSize={'11px'}>
                                                {prod.descricao}
                                            </Grid>
                                            <Grid item xs={2} fontSize={'11px'} textAlign={'right'} style={{ color: (prod.especie == 1 ? 'black' : 'red') }}>
                                                {(prod.especie == 1 ? numberWithCommas(prod.unitario * prod.quantidade) : numberWithCommas((prod.unitario * prod.quantidade) * -1))}
                                            </Grid>
                                        </React.Fragment>
                                    ))}
                                {
                                    <Grid container spacing={0} sx={{ margin: '0', padding: '0', marginLeft: '5px', paddingRight: '0px' }}>
                                        <Grid item xs={8} style={{ height: '4px', alignSelf: 'center' }}></Grid>
                                        <Grid item xs={4}><Divider style={{ height: '4px', alignSelf: 'center' }} /></Grid>
                                        <Grid item xs={7} fontSize={'11px'} textAlign={'right'}><strong>R$</strong></Grid>
                                        <Grid item xs={5} fontSize={'11px'} textAlign={'right'}><strong>{numberWithCommas(totalVenda)}</strong></Grid>
                                    </Grid>
                                }
                            </Grid>
                        </CardContent>
                    </MuiCard>
                );               
                adicionarObjetoNaColuna(colunaAtual, exibirObjeto);
            }
        });

        // Agrupar as vendas com base no id_venda
        // props.especieParcial.forEach((xespec, index) => {
        //     setUrlQRCode(xespec.pix_copia_cola);
            let exibirObjetoPagamentos =
                <>
                    <Box ref={componentRef} sx={{ marginLeft:'-5px', marginRight:'-5px', marginTop:'-10px' }}>
                        <PaginaCardNotasFaturadasReciboPagamentos props={props} />
                    </Box>
                </>
            adicionarObjetoNaColuna(2, exibirObjetoPagamentos);
        // });
    }


    const calcularTotalVenda = (vendaId) => {
        const itensFiltrados = props.props.satonParcial.filter(
            prod => (prod.id_venda + "-" + prod.id_venda_loja) === vendaId
        );

        // Atualiza a variável itensNaPagina com o número de itens filtrados
        itensNaPagina += itensFiltrados.length;

        if (itensNaPagina > limiteLinhasPorPagina) {
            itensNaPagina = itensFiltrados.length;
        }

        // Calcula o total com base nos itens filtrados
        return itensFiltrados.reduce((total, prod) => {
            const valorItem = prod.unitario * prod.quantidade;
            // Armazena o número do item na página (poderia ser feito após o reduce também)
            // vendasAgrupadasLinhasPorColuna.push(itensNaPagina);     
            if (prod.especie === 1) {
                return total + valorItem; // Não altera o valor
            } else {
                return total + (valorItem * -1); // Multiplica por -1
            }
        }, 0); // Inicializa o total com 0
    };

    return (
        <>
        <BrowserView>
        <>
            <Grid container justifyContent={"center"} spacing={2}>
                <Grid item xs={6}>
                    <Box display="flex"
                        justifyContent="right"
                        variant={'rounded'}
                        alignItems="center"><Button bgcolor={'color'} onClick={() => handleCloseModal() } startIcon={<Avatar src={CloseIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
                </Grid>
                <Grid item xs={6}>
                    <Box display="flex"
                        justifyContent="left"
                        variant={'rounded'}
                        alignItems="center"><Button bgcolor={'color'} onClick={handlePrint} startIcon={<Avatar src={ImpressaoIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
                </Grid>
            </Grid>
            <div className="div to print" ref={dataToPrintRef} style={{ pageBreakInside: 'avoid' }}>
                <Grid container justifyContent={"center"} spacing={2} marginTop={'-10px'}>
                    <Grid item xs={1.5}>
                        <Box display="flex"
                            justifyContent="left"
                            variant={'rounded'}
                            alignItems="left"><img src={LogoNafil} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '130px', height: 'auto', marginLeft: '8px' }} /></Box>
                    </Grid>
                    <Grid item xs={8.0}>
                        <Box display="flex"
                            justifyContent="center"
                            variant={'rounded'}
                            alignItems="center"><Typography sx={{ paddingTop: '5px' }}>Cobrança Efetuado no Processo {processoNumero}</Typography></Box>
                    </Grid>
                    <Grid item xs={2.5}>
                        <Box display="flex"
                            justifyContent="right"
                            variant={'rounded'}
                            alignItems="right"><Typography sx={{ marginRight: '10px', paddingTop: '5px' }}>{formatarDataHora(processoData, 4)}</Typography></Box>
                    </Grid>
                </Grid>

                <Grid container spacing={0.6} sx={{ padding: '5px', paddingLeft: '8px', paddingRight: '8px' }} >
                    {/* Coluna Esquerda */}
                    <Grid item xs={4}>
                        {/* {vendasAgrupadas.filter((_, index) => index % 3 === 0)} */}
                        {colunas[0]}
                    </Grid>

                    {/* Coluna Central */}
                    <Grid item xs={4}>
                        {/* {vendasAgrupadas.filter((_, index) => index % 3 === 1)} */}
                        {colunas[1]}
                    </Grid>

                    {/* Coluna Direita */}
                    <Grid item xs={4}>
                        {/* {vendasAgrupadas.filter((_, index) => index % 3 === 2)} */}
                        {colunas[2]}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sx={{ height: '10px' }}></Grid>
                </Grid>
            </div>
        </>
        </BrowserView>

        <MobileView>
            <>
            <Grid container justifyContent={"center"} spacing={2}>
                <Grid item xs={6}>
                    <Box display="flex"
                        justifyContent="right"
                        variant={'rounded'}
                        alignItems="center"><Button bgcolor={'color'} onClick={() => handleCloseModal() } startIcon={<Avatar src={CloseIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
                </Grid>
                <Grid item xs={6}>
                    <Box display="flex"
                        justifyContent="left"
                        variant={'rounded'}
                        alignItems="center"><Button bgcolor={'color'} onClick={handlePrint} startIcon={<Avatar src={ImpressaoIcon} variant={'square'} alignItems={'center'} sx={{ height: '45px', width: '50px' }} />} /></Box>
                </Grid>
            </Grid>
            <div className="div to print" ref={dataToPrintRef} style={{ pageBreakInside: 'avoid' }}>
                <Grid container justifyContent={"center"} spacing={2} marginTop={'-10px'}>
                    <Grid item xs={1.5}>
                        <Box display="flex"
                            justifyContent="left"
                            variant={'rounded'}
                            alignItems="left"><img src={LogoNafil} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '130px', height: 'auto', marginLeft: '8px' }} /></Box>
                    </Grid>
                    <Grid item xs={8.0}>
                        <Box display="flex"
                            justifyContent="center"
                            variant={'rounded'}
                            alignItems="center"><Typography sx={{ paddingTop: '5px' }}>Cobrança Efetuado no Processo {processoNumero}</Typography></Box>
                    </Grid>
                    <Grid item xs={2.5}>
                        <Box display="flex"
                            justifyContent="right"
                            variant={'rounded'}
                            alignItems="right"><Typography sx={{ marginRight: '10px', paddingTop: '5px' }}>{formatarDataHora(processoData, 4)}</Typography></Box>
                    </Grid>
                </Grid>

                <Grid container spacing={0.6} sx={{ padding: '5px', paddingLeft: '8px', paddingRight: '8px' }} >
                    {/* Coluna Esquerda */}
                    <Grid item xs={12}>
                        {/* {vendasAgrupadas.filter((_, index) => index % 3 === 0)} */}
                        {colunas[0]}
                    </Grid>

                    {/* Coluna Central */}
                    <Grid item xs={12}>
                        {/* {vendasAgrupadas.filter((_, index) => index % 3 === 1)} */}
                        {colunas[1]}
                    </Grid>

                    {/* Coluna Direita */}
                    <Grid item xs={12}>
                        {/* {vendasAgrupadas.filter((_, index) => index % 3 === 2)} */}
                        {colunas[2]}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sx={{ height: '10px' }}></Grid>
                </Grid>
            </div>
        </>
        </MobileView>
        </>
    );
};
export default Card;
